<template>
  <v-list-item class="px-0 py-3 d-flex flex-column">
    <v-list-item-title class="insights-filter-title">{{ $t('insights.filters.contracts')}}</v-list-item-title>
    <VfAutoSelect
      :items="contracts"
      v-model="selectedContractsModel"
      nameField="contractName"
      valueField="id"
      hide-details
      allowSingleDelete
      :placeholder="$t('insights.filters.contractsPlaceholder')"
      class="pb-1 pt-3 insights-filter-input-text full-width"
    />
  </v-list-item>
</template>

<script>
export default {
  name: 'ContractsFilter',
  props: {
    contracts: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedContracts: {
      type: Array
    }
  },
  emits: ['selectedContractsInput'],
  computed: {
    selectedContractsModel: {
      get () {
        return this.selectedContracts
      },
      set (value) {
        this.$emit('selectedContractsInput', value)
      }
    }
  }
}
</script>

<style scoped>
</style>
